import type { IconData } from '@stacksjs/iconify-core'

export const otherUiLayers: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 0L0 3v2l8 3l8-3V3z\"/><path fill=\"currentColor\" d=\"M16 5.123v1.479l-8 3l-8-3v-.608V9l8 3l8-3z\"/><path fill=\"currentColor\" d=\"M16 9.123v1.479l-8 3l-8-3v-.608V13l8 3l8-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiLayers
